import { Component, inject } from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggle } from "@angular/material/slide-toggle";
import {CheckStepperService} from '../../services/check-stepper';

@Component({
  selector: 'app-checklist-selfcheck',
  imports: [MatSliderModule, MatSlideToggle],
  templateUrl: './checklist-selfcheck.html',
  styleUrl: './checklist-selfcheck.scss',
})
export class ChecklistSelfcheck {
  readonly checkStepperService = inject(CheckStepperService);
  selfChecks = this.checkStepperService.selfChecks;

  toggleChanged(item: any, event: any) {
    this.checkStepperService.updateSelfCheck(item.id, event.checked);

    const done = this.selfChecks()
      .filter(c => c.id !== 4)
      .every(c => c.value === true);

    this.checkStepperService.setSelfCheckDone(done);
  }

  saveToggleState(id: number){
    this.selfChecks.update(list =>
      list.map(item =>
        item.id === id
        ? {...item, value: true, disabled: true}
        : item
      )
    )
  }
}
